/** Move money's sides and the served shortfall (TMMAPP-0108, MM-D-114). */
import type { AssignSide } from '@/api/allocations';
import { isApiError } from '@/api/errors';

export const UNASSIGNED_SIDE = 'unassigned';

/** `unassigned` or an envelope id, as the selects hold them. */
export function toSide(value: string): AssignSide {
  return value === UNASSIGNED_SIDE ? { unassigned: true } : { envelopeId: Number(value) };
}

/** The served `details.availableMinor` of an `INSUFFICIENT_TO_ASSIGN`, else null. */
export function availableOf(error: unknown): number | null {
  if (!isApiError(error)) return null;
  const backend = error.details.backend;
  if (typeof backend !== 'object' || backend === null) return null;
  const value = (backend as Record<string, unknown>).availableMinor;
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}
